'use strict';
import React from 'react';
import flux from 'utils/flux';


var SamlError = React.createClass({
    displayName: 'SamlError',
    mixins: [],

    render() {
        return (
            <div className="page samil-error">
                <h4>{flux.t('saml_error_message')} </h4>
            </div>
        );
    }
});

module.exports = SamlError;



// WEBPACK FOOTER //
// ./app/pages/samlError/index.jsx